// import XLSX from "xlsx-js-style";
//
// export const downloadXlsx = (fileData) => {
//   const wb = XLSX.utils.book_new();
//
//   // Define some styles
//   const headerStyle = {
//     font: { bold: true, color: { rgb: "FFFFFF" } },
//     fill: { fgColor: { rgb: "4F81BD" } },
//     alignment: { horizontal: "center", vertical: "center" },
//     border: {
//       top: { style: "thin", color: { rgb: "000000" } },
//       bottom: { style: "thin", color: { rgb: "000000" } },
//       left: { style: "thin", color: { rgb: "000000" } },
//       right: { style: "thin", color: { rgb: "000000" } },
//     },
//   };
//
//   const bodyStyle = {
//     font: { color: { rgb: "000000" } },
//     alignment: { horizontal: "left", vertical: "center" },
//     border: {
//       top: { style: "thin", color: { rgb: "000000" } },
//       bottom: { style: "thin", color: { rgb: "000000" } },
//       left: { style: "thin", color: { rgb: "000000" } },
//       right: { style: "thin", color: { rgb: "000000" } },
//     },
//   };
//
//   // Apply styles to header and body
//   const styledHeader = fileData.header.map((cell) => ({ v: cell, s: headerStyle }));
//   const styledBody = fileData.body.map((row) => row.map((cell) => ({ v: cell, s: bodyStyle })));
//
//   // Create sheets with styled data
//   const fobSales = XLSX.utils.aoa_to_sheet([styledHeader, ...styledBody]);
//   const openPurchase = XLSX.utils.aoa_to_sheet([styledHeader, ...styledBody]);
//
//   // Set the width of the first column
//   const columnWidths = [{ wch: 20 }, { wch: 30 }]; // Set the width of the first column to 20 characters and the second column to 30 characters
//   fobSales["!cols"] = columnWidths;
//   openPurchase["!cols"] = columnWidths;
//
//   // Append sheets to workbook
//   XLSX.utils.book_append_sheet(wb, fobSales, "FOB Sales");
//   XLSX.utils.book_append_sheet(wb, openPurchase, "Open Purchase");
//
//   // Write the workbook to a file
//   XLSX.writeFile(wb, `${fileData.name}.xlsx`);
// };
import XLSX from "xlsx-js-style";

const flattenParser = (input) => {
    const result = [];
    const flatten = (item) => {
        if (typeof item === 'string') {
            // String: add as-is
            result.push(item);
        } else if (Array.isArray(item)) {
            // Array: recursively flatten each element
            item.forEach(element => flatten(element));
        } else if (item !== null && typeof item === 'object') {
            // Object: add key, then value for each property
            Object.entries(item).forEach(([key, value]) => {
                result.push(key);
                flatten(value);
            });
        } else {
            // Other primitives (numbers, booleans, null, undefined)
            result.push(item);
        }
    }
    flatten(input);
    return result;
};

const transposeArrays = (input) => {
    if (!Array.isArray(input) || input.length === 0) {
        return [];
    }
    // Find the maximum length among all sub-arrays
    const maxLength = Math.max(...input.map(arr => Array.isArray(arr) ? arr.length : 0));
    const result = [];

    // Create arrays for each index position
    for (let i = 0; i < maxLength; i++) {
        const newArray = [];
        // Go through each sub-array and collect the element at index i
        for (let j = 0; j < input.length; j++) {
            if (Array.isArray(input[j]) && i < input[j].length) {
                newArray.push(input[j][i]);
            }
            else {
                newArray.push(null)
            }
        }
        result.push(newArray);
    }

    return result;
};

export const downloadXlsx = (data) => {
    const wb = XLSX.utils.book_new();
    data.forEach(v => {
        const keys = Object.keys(v);
        const values = Object.values(v);
        const rows = values.map(row => flattenParser(row))
        const sheet = XLSX.utils.aoa_to_sheet([keys, ...transposeArrays(rows)])
        XLSX.utils.book_append_sheet(wb, sheet, 'extracted')
    })
    XLSX.writeFile(wb, `${new Date().toLocaleString()}.xlsx`);
};
